/**
 * Converts a strings 1st letter to uppercase
 * Also handles camelCase first words
 */
const sentenceCase = (str: string) => {
  // seperate camelCase words
  const result = str.replace(/([a-z])([A-Z])/g, "$1 $2");
  const string = result.charAt(0) + result.slice(1).toLowerCase();

  return string.charAt(0).toUpperCase() + string.substring(1);
};

export default sentenceCase;
